// src/pages/Home/components/Navbar3/ui/ThemeToggle.jsx

import React from "react";

import {
  FaMoon,
  FaSun,
} from "react-icons/fa";

import {
  cx,
} from "../utils/navbar3.utils";

export default function ThemeToggle({
  isDarkMode,
  onToggle,
  variant = "desktop",
}) {
  const isMobile =
    variant === "mobile";

  const label = isDarkMode
    ? "Activer le thème clair"
    : "Activer le thème sombre";

  return (
    <button
      type="button"
      onClick={onToggle}
      aria-label={label}
      title={label}
      className={cx(
        [
          "flex shrink-0",
          "items-center",
          "justify-center",
          "rounded-full",
          "text-white",
          "transition",
          "duration-200",
          "hover:bg-white/10",
          "active:scale-90",
          "focus-visible:outline-none",
          "focus-visible:ring-2",
          "focus-visible:ring-white/60",
        ].join(" "),
        isMobile
          ? "h-8 w-8"
          : "h-9 w-9",
      )}
    >
      {isDarkMode ? (
        <FaSun
          className={
            isMobile
              ? "text-base"
              : "text-lg"
          }
        />
      ) : (
        <FaMoon
          className={
            isMobile
              ? "text-base"
              : "text-lg"
          }
        />
      )}
    </button>
  );
}